import { Transition } from "@headlessui/react";
import { FC, Fragment } from "preact/compat";
import { getMe, requestApi } from "~/core";
import LogoutIcon from "@material-design-icons/svg/outlined/logout.svg";
import { IconButton } from "~/components";

// @TODO: to be deleted
const Base: FC = () => {
    const { me, refetch } = getMe();

    if (!me.value) {
        return null;
    }

    const handleLogout = async () => {
        await requestApi("/auth/logout", "POST");
        refetch();
    };

    return (
        <>
            <Transition
                show={Boolean(me.value)}
                as={Fragment}
                enter="duration-500"
                enterFrom="opacity-0 -translate-y-12"
                enterTo="opacity-100 translate-y-0"
            >
                <div className="absolute top-4 right-4">
                    <div className="flex items-center p-2 text-sm bg-white border border-gray-300 rounded-xl">
                        <span className="mr-3 text-sky-800">
                            {me.value?.email}
                        </span>
                        <IconButton title="Logout" onClick={handleLogout}>
                            <LogoutIcon width="14" height="14" />
                        </IconButton>
                    </div>
                </div>
            </Transition>
        </>
    );
};

export default Base;
